export default "/app/global-wrapper-client/static/3cf6986f34e36ed41e2a5541351eb9d6.ttf";